import { USMapLink, CanadaMapLink } from './costants';


/**
 * This method returns the default link for 
 * the map displayed
 */
export const getDefaultMapLink = (storeId) => {
    const sites = ['us', 'ca'];
    let defaultCountry = sites[0];
    if (storeId === "10852") {
        defaultCountry = sites[1];
    }
    if (defaultCountry === 'ca') {
        return CanadaMapLink;
    }
    return USMapLink;
}

/**
 * This method takes in a flag and a text
 * and return that text within a div element,
 * with the character '\n' rendered as a new line
 * and bold text if the flag is set to true 
 * @param {isBold, text}  
 */
export const TextLine = ({ isBold, text }) => {
    // TOD add line-height
    return <div className={isBold ? 'new-line bold' : 'new-line'}>{text}</div>
}

export const roundNumber = (number) => {
    return Math.round((number) * 100) / 100
}




